import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { I18NextPipe } from 'angular-i18next';

import { ErrorResponse } from '../backend-client/models/SharedKernel/Models/Error/error-response';
import {
  MxAppInitService,
  MxLoggingService,
  MxNotificationService,
  MxNotificationSeverity,
} from './services';

@Injectable()
export class MxGlobalErrorHandler implements ErrorHandler {
  constructor(
    private notificationService: MxNotificationService,
    private loggingService: MxLoggingService,
    private appInitService: MxAppInitService,
    private router: Router,
    private i18NextPipe: I18NextPipe
  ) {}

  handleError(error: Error | HttpErrorResponse) {
    if (error instanceof HttpErrorResponse) {
      if (error.status === 400) {
        this.notificationService.show({
          type: this.notificationService.getNotificationSeverityByBackendNotificationType(
            (error.error as ErrorResponse).severity
          ),
          title: (error.error as ErrorResponse).errorTitle,
          message: (error.error as ErrorResponse).friendlyMessage,
          rawDetails: (error.error as ErrorResponse).parameters?.['details'],
        });
        this.loggingService.log('LOG: (400)', { error: error });
      } else if (error.status === 500) {
        this.notificationService.show({
          type: this.notificationService.getNotificationSeverityByBackendNotificationType(
            (error.error as ErrorResponse).severity
          ),
          title: (error.error as ErrorResponse).errorTitle,
          message: (error.error as ErrorResponse).friendlyMessage,
          rawDetails: (error.error as ErrorResponse).parameters?.['details'],
          sticky: true,
          clearMessages: true,
        });
        this.loggingService.error('ERROR: (400)', { error: error });
      } else {
        this.router.navigate(['pages', 'error']);
        this.loggingService.error('ERROR: (SERVER_UNKNOW)', { error: error });
      }
    } else if (error instanceof Error) {
      let message = error.message ? error.message : error.toString();

      if (!this.appInitService.currentConfig?.log.debug) {
        message = this.i18NextPipe.transform(
          'message:Something_went_wrong_in_our_end'
        );
      }

      this.notificationService.show({
        type: MxNotificationSeverity.Error,
        message: message,
        rawDetails: error.stack,
        sticky: true,
        clearMessages: true,
      });
      this.loggingService.error('ERROR: (CLIENT_UNKNOW)', { error: error });
    } else {
      this.loggingService.error('ERROR: (UNKNOW)', { error: error });
    }
  }
}
